.o0goes0 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.o0goes1 {
  margin-top: 16px;
}